import { FC, JSX } from 'react';

import classNames from 'classnames';

import { BUTTON_SIZES, BUTTON_TYPES, EvButton, EvCard } from '@evinced-private/ui-common';

import { TenantExpirationDetails } from '../../services/TenantsService';
import { formatDate } from '../common/helpers/DateFormatHelper';
import { ContactUsButton } from '../contact-us-button/ContactUsButton';

export interface IProductCardProps {
	cardTitle: string;
	contentText: string;
	learnMoreLink?: string;
	learnMoreButtonText?: string;
	goToProductButtonText: string;
	goToProductButtonOnClick?: () => void;
	expirationDetails?: TenantExpirationDetails;
	primaryButtonMessage?: string;
}
export const ProductCard: FC<IProductCardProps> = ({
	cardTitle,
	contentText,
	learnMoreLink,
	learnMoreButtonText,
	expirationDetails,
	goToProductButtonText,
	goToProductButtonOnClick,
	primaryButtonMessage
}: IProductCardProps) => {
	const renderContactUsButton = (title: string): JSX.Element => (
		<ContactUsButton title={title} product={cardTitle} />
	);
	const renderPrimaryButton = (): JSX.Element => {
		let mainButton;
		let footerText;

		if (!expirationDetails || !goToProductButtonOnClick) {
			mainButton = renderContactUsButton('Would you like to try it out?');
		} else if (expirationDetails?.isExpired) {
			mainButton = renderContactUsButton('Would you like to renew your license?');
			footerText = 'Your license has expired';
		} else {
			mainButton = (
				<EvButton
					type={BUTTON_TYPES.PRIMARY}
					onClick={() => goToProductButtonOnClick?.()}
					size={BUTTON_SIZES.BIG}
				>
					{goToProductButtonText}
				</EvButton>
			);

			if (expirationDetails?.isLicensedForever) {
				footerText = primaryButtonMessage || 'Your license is active';
			} else if (expirationDetails?.date) {
				footerText = (
					<>
						Your license will expire on <br /> {formatDate(expirationDetails.date)}
					</>
				);
			}
		}

		return (
			<div className="button-with-message">
				{mainButton}
				<span
					className={classNames('button-message', {
						error: expirationDetails?.isExpired
					})}
				>
					{footerText}
				</span>
			</div>
		);
	};

	const renderSecondaryButton = (): JSX.Element => {
		if (!learnMoreLink || !learnMoreButtonText) {
			return null;
		}

		return (
			<EvButton
				type={BUTTON_TYPES.GHOST}
				onClick={() => window.open(learnMoreLink, '_blank')}
				size={BUTTON_SIZES.BIG}
			>
				{learnMoreButtonText}
			</EvButton>
		);
	};
	const renderFooter = (): JSX.Element => {
		return (
			<div className="welcome-screen-card-footer">
				{renderSecondaryButton()}
				{renderPrimaryButton()}
			</div>
		);
	};
	return (
		<EvCard title={cardTitle} footer={renderFooter()}>
			{contentText}
		</EvCard>
	);
};
